exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".referans-report-table[data-v-e3b44a5e]{width:100%;margin-top:4px}.referans-report-table>*[data-v-e3b44a5e]{width:100%}", ""]);

// exports
